const layout = {
  sideBar: {
    menu: {
      jobs: {
        title: 'Ordenes',
        children: {
          jobs: 'Ordenes',
        },
      },
    },
  },
};

export default layout;
